import { TFunction } from "react-i18next";

export const TodoStates = (t: TFunction<"translate", undefined>) => [
    { label: t('singleTodo.new'), id: 0 },
    { label: t('beingResolved'), id: 1 },
    { label: t('singleTodo.resolved'), id: 2 },
];